import { LyMainProductFormBase } from './base'

if (!customElements.get('ly-main-product-form-price')) {
    customElements.define('ly-main-product-form-price', class extends LyMainProductFormBase {

        currentPriceDom = null
        originalPriceDom = null
        discountJsDom = null

        connectedCallback() {
            super.connectedCallback()

            this.currentPriceDom = this.querySelector('.current-price')
            this.originalPriceDom = this.querySelector('.original-price')
            this.discountDom = this.querySelector('.discount')
            this.discountJsDom = this.querySelector('.discount .js')

            this.updateDiscount(this.dataset.current, this.dataset.original)
        }

        disconnectedCallback() {

            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId }) => {
            const config = this._variantConfigs[variantId]
            if (!config) return
            const { current, original } = config
            this.currentPriceDom.textContent = this.formatter.format(current / 100)
            this.originalPriceDom.textContent = this.formatter.format(original / 100)
            this.updateDiscount(current, original)

            this.originalPriceDom.classList.toggle('ly-hide', current === original)
            this.discountDom.classList.toggle('ly-hide', current === original)
        }

        updateDiscount = (current, original) => {
            const discountRatio = (current * 100) / original;
            const discountPercent = 100 - discountRatio

            this.discountJsDom.textContent = `${discountPercent.toFixed(0)}%`
        }
    })
}